var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:{
    [_vm.$c('message')]: true,
    [_vm.$c(`message-${_vm.status}`)]: true,
    [_vm.$c(`message-${_vm.display}`)]: true
  },attrs:{"ui":_vm.realUi}},[(_vm.icons[_vm.status] && _vm.display !== 'simple')?_c('veui-icon',{ref:"icon",class:_vm.$c('message-icon'),attrs:{"name":_vm.icons[_vm.status]}}):_vm._e(),(_vm.display === 'popup')?_c('veui-popover',{attrs:{"target":"icon","position":"right"}},[_vm._t("default")],2):_c('div',{class:_vm.$c('message-content')},[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }